import { firebase } from "./firebase";

const messaging = firebase.messaging();

messaging.usePublicVapidKey(
  "BFozZM7dt6CAA0uMDWR2zlz7-Tu1O4dzBVAkd2EmcTO0Euy8XKMu8sE5-r2jYo2id0z0JI_jCPETYruEHSP3gSI"
);

let currentToken = null;

const notificationPromise = Notification.requestPermission().then(
  permission => {
    if (permission === "granted") {
      console.log("Notification permission granted.");
      messaging
        .getToken()
        .then(token => {
          if (token) {
            currentToken = token;
            return token;
          } else {
            currentToken = null;
            console.error(
              "No Instance ID token available. Request permission to generate one."
            );
          }
          return null;
        })
        .catch(err => {
          console.error("An error occurred while retrieving token. ", err);
        });
    } else {
      throw new Error("Unable to get permission to notify");
    }
  }
);

function refreshTokenEvent(cb) {
  if (cb && typeof cb === "function") {
    messaging.onTokenRefresh(() => {
      messaging
        .getToken()
        .then(refreshedToken => {
          currentToken = refreshedToken;
          cb(refreshedToken);
        })
        .catch(err => {
          currentToken = null;
          console.error("Unable to retrieve refreshed token ", err);
        });
    });
  }
  // RefreshToken
}

async function generateNotification(salaId) {
  if (!salaId) return Promise.reject(new Error("Insuficient Paramethers"));
  const initRq = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ sala: salaId, token: currentToken })
  };
  const url =
    "https://us-central1-edutech-267418.cloudfunctions.net/apiFunction/api/v1/notifications/dispatch";
  return fetch(url, initRq).then(res =>
    res.ok
      ? res.json()
      : (() => {
          throw new Error("Invalid request");
        })()
  );
}

async function setServerToken(elements) {
  elements.token = currentToken;
  const initRq = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(elements)
  };
  const url =
    "https://us-central1-edutech-267418.cloudfunctions.net/apiFunction/api/v1/notifications";
  return fetch(url, initRq).then(res =>
    res.ok
      ? res.json()
      : (() => {
          throw new Error("Invalid request");
        })()
  );
}

export let message = {
  async setTokenWithUserGroups(elements) {
    setServerToken(elements);
    refreshTokenEvent(() => {
      setServerToken(elements);
    });
  },
  getToken() {
    return notificationPromise.then(() => currentToken);
  },
  messaging,
  refreshTokenEvent,
  generateNotification
};
